
namespace RedBullMOBILE360.AutomaticReports {
    export class ReportPartColumns {
        static columnsKey = 'AutomaticReports.ReportPart';
    }
}